import PropTypes from 'prop-types';
import { twMerge } from 'tailwind-merge';

const GamificationProgressBar = ({ className, ...rest }) => (
  <meter
    className={twMerge(
      'h-2 w-full rounded-3 bg-neutral-high-200 [&::-moz-meter-bar]:rounded-3 [&::-moz-meter-bar]:bg-info-300 [&::-webkit-meter-bar]:h-2 [&::-webkit-meter-bar]:w-full [&::-webkit-meter-bar]:rounded-3 [&::-webkit-meter-optimum-value]:h-2 [&::-webkit-meter-optimum-value]:rounded-3 [&::-webkit-meter-optimum-value]:bg-info-300 dark:[&::-webkit-meter-optimum-value]:bg-info-300',
      className
    )}
    {...rest}
  />
);

GamificationProgressBar.propTypes = {
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

export default GamificationProgressBar;
